import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PortableText } from "@portabletext/react";

// import assets
import DownSrc from "../../assets/images/svg-down.webp";

// EN/JP answers share the `.sub-link` class for link color (scoped under
// both .sub-text-1 and .sub-text-2 in component.scss) but use different
// default fonts. The `en`/`jp` decorators let editors swap to the other
// language's font inline (e.g. a JP word inside an EN paragraph).
const sharedMarks = {
  link: ({ value, children }) => (
    <a
      href={value?.href}
      className="sub-link"
      target={value?.openInNewTab ? "_blank" : undefined}
      rel={value?.openInNewTab ? "noopener noreferrer" : undefined}
    >
      {children}
    </a>
  ),
  en: ({ children }) => (
    <span className="font-notoserifgeorgian">{children}</span>
  ),
  jp: ({ children }) => <span className="font-kleeone">{children}</span>,
};

const enAnswerComponents = {
  block: {
    normal: ({ children }) => <p className="font-notoserifgeorgian">{children}</p>,
  },
  marks: sharedMarks,
};

const jpAnswerComponents = {
  block: {
    normal: ({ children }) => <p className="font-kleeone">{children}</p>,
  },
  marks: sharedMarks,
};

const FAQItem = ({ question, answer }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="about-faq-item">
      <button className="faq-item-button" onClick={() => setIsOpen(!isOpen)}>
        <div className="faq-item-btn-text">
          <div
            className="question-text-1 font-amaticsc-bold"
            style={{ whiteSpace: "pre-line" }}
          >
            {question?.en}
          </div>
          <div
            className="question-text-2 font-zenkurenaido"
            style={{ whiteSpace: "pre-line" }}
          >
            {question?.jp}
          </div>
        </div>
        <motion.div
          animate={{ rotate: isOpen ? 180 : 0 }}
          transition={{ duration: 0.2 }}
        >
          <img src={DownSrc} className="faq-item-img" alt="down" />
        </motion.div>
      </button>

      <AnimatePresence initial={false}>
        {isOpen && (
          <motion.div
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { height: "auto", opacity: 1 },
              collapsed: { height: 0, opacity: 0 },
            }}
            transition={{ duration: 0.2, ease: "easeInOut" }}
            className="faq-item-content"
          >
            <div className="faq-item-subcontent">
              <div className="font-notoserifgeorgian sub-text-1">
                <PortableText value={answer?.en} components={enAnswerComponents} />
              </div>
              <div className="font-kleeone sub-text-2">
                <PortableText value={answer?.jp} components={jpAnswerComponents} />
              </div>
              <hr className="bottom-hr" />
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default FAQItem;
